import Collapse from "bootstrap/js/src/collapse";
window.Collapse = Collapse;
